import React, { useRef } from 'react';
import './VideoPlayer.css';

const VideoPlayer = ({ videoUrl, title, description, isUploaded = false, fullWidth = false }) => {
  const videoRef = useRef(null);

  // Check if URL is a YouTube video
  const isYouTube = videoUrl && (
    videoUrl.includes('youtube.com') || 
    videoUrl.includes('youtu.be')
  );

  // Extract YouTube video ID and convert to embed URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    
    // Handle youtube.com/watch?v=VIDEO_ID
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/);
    if (youtubeMatch && youtubeMatch[1]) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    }
    
    // If already an embed URL, return as is
    if (url.includes('youtube.com/embed/')) {
      return url;
    }
    
    return url;
  };

  if (!videoUrl) {
    return (
      <div className={`video-player-container ${fullWidth ? 'video-player-full-width' : ''}`}>
        <div className="video-header">
          {title && <h3 className="video-title">{title}</h3>}
          <p className="video-description">Video link is not available yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`video-player-container ${fullWidth ? 'video-player-full-width' : ''}`}>
      {(title || description) && (
        <div className="video-header">
          <div className="video-title-row">
            {title && <h3 className="video-title">{title}</h3>}
            <span className="video-type-badge">
              {isYouTube ? 'YouTube' : (isUploaded ? 'Uploaded' : 'Video')}
            </span>
          </div>
          {description && <p className="video-description">{description}</p>}
        </div>
      )}

      <div className="video-player">
        {isYouTube ? (
          // YouTube videos - use iframe
          <iframe
            className="video-element"
            src={getYouTubeEmbedUrl(videoUrl)}
            title={title || "Video"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          // Uploaded videos (Cloudinary or local) - use video tag
          <video
            ref={videoRef}
            className="video-element"
            controls
            preload="metadata"
          >
            <source src={videoUrl} />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer; 
